import { useMemo } from "react";

const setInnerHTML = (content) => {
  return { __html: content };
};

const Project = ({ imageUrl, url, name, description, tech }) => {
  const projectImageStyle = useMemo(
    () => ({
      background: "url(" + imageUrl + ") top center no-repeat",
      height: "320px",
      backgroundSize: "cover",
    }),
    [imageUrl]
  );

  return (
    <div className="project">
      <h3>
        <a href={url} title={name} target="_blank" rel="noreferrer">
          {name}
        </a>
      </h3>
      <div className="projectImage" style={projectImageStyle}>
        <div className="over" />
      </div>
      <p
        className="projCast"
        dangerouslySetInnerHTML={setInnerHTML(description)}
      />
      <p className="projTech">
        Main technologies: <em>{tech}</em>
      </p>
      <p className="projLink">
        <strong>
          Go to{" "}
          <a href={url} title={name + "'s site"} target="_blank" rel="noreferrer">
            the project's website
          </a>
        </strong>
      </p>
    </div>
  );
};

export default Project;
